export default function removeNullsInObject(obj: Record<any, any>): Record<any, any> {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}
